import { render, staticRenderFns } from "./FragmentJsmk.vue?vue&type=template&id=5270ce12&"
import script from "./FragmentJsmk.vue?vue&type=script&lang=ts&"
export * from "./FragmentJsmk.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports